import { useIntl } from "react-intl";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

import {
    OffsetIconCollection,
    iconDataProps
} from "@/patterns/offset-icon-collection/offset-icon-collection";

export const IntegrationsSection = () => {
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const intl = useIntl();

    const iconData: iconDataProps[] = [
        {
            url: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ms-teams.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.microsoft-alt-text",
                defaultMessage: "Microsoft Teams icon"
            })
        },
        {
            url: "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-drive.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.google-drive-alt-text",
                defaultMessage: "Google Drive icon"
            })
        },
        {
            url: "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-docs.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.google-doc-alt-text",
                defaultMessage: "Google Docs icon"
            })
        },

        {
            url: "https://wac-cdn.atlassian.com/misc-assets/webp-images/figma.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.figma-alt-text",
                defaultMessage: "Figma icon"
            })
        },

        {
            url: "https://wac-cdn.atlassian.com/misc-assets/webp-images/miro.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.miro-alt-text",
                defaultMessage: "Miro icon"
            })
        },

        {
            url: "https://wac-cdn.atlassian.com/misc-assets/webp-images/slack.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.teams-alt-text",
                defaultMessage: "Teams icon"
            })
        },
        {
            url: "https://wac-cdn.atlassian.com/misc-assets/webp-images/zoom.webp",
            altText: intl.formatMessage({
                id: "jira-product-tour.integrations-section.zoom-alt-text",
                defaultMessage: "Zoom icon"
            })
        }
    ];

    const handleClick = () => {
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            attributes: {
                name: "atlas-55799-integrations-button-clicked",
                section: "integration-section"
            }
        }).fire();
    };

    return (
        <OffsetIconCollection
            headingText={intl.formatMessage({
                id: "jira-product-tour.integrations-section.heading-text",
                defaultMessage: "Meets teams where they work"
            })}
            bodyText={intl.formatMessage({
                id: "jira-product-tour.integrations-section.body-text",
                defaultMessage:
                    "If your team uses it, we integrate with it. Easily add your favorite tools from the Atlassian Marketplace, keeping Jira as your central source of truth."
            })}
            iconData={iconData}
            ctaText={intl.formatMessage({
                id: "jira-product-tour.integrations-section.cta-text",
                defaultMessage: "See all integrations"
            })}
            ctaLink="https://marketplace.atlassian.com"
            ctaOnClickFunc={handleClick}
        />
    );
};
IntegrationsSection.displayName = "IntegrationsSection";
